import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import './TasbihPage.css';

export const TasbihPage: React.FC = () => {
  const { colors } = useTheme();
  const { t } = useLanguage();
  const [count, setCount] = useState(0);

  return (
    <div className="tasbih-page" style={{ backgroundColor: colors.background }}>
      <div className="tasbih-container">
        <div className="counter-circle" style={{ borderColor: colors.tint }}>
          <span className="counter-text" style={{ color: colors.tint }}>{count}</span>
        </div>
        <div className="button-row">
          <button onClick={() => setCount(0)} className="reset-button" style={{ borderColor: colors.border, color: colors.text }}>
            {t.more.reset}
          </button>
          <button onClick={() => setCount(c => c + 1)} className="count-button" style={{ backgroundColor: colors.tint }}>
            {t.more.count}
          </button>
        </div>
      </div>
    </div>
  );
};
